import React,{Component} from 'react'
import SimpleReactValidator from 'simple-react-validator';
import {adminLogin} from '../store/apiRoutes'
import {ToastContainer,  toast } from 'react-toastify';
import $ from 'jquery'

class Login extends Component {

  constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        this.state = {
            email: '',
            password: '',
            loading:false
        }
  }
  
  componentDidMount(){
  
    if(sessionStorage.getItem('adminDetails') !== undefined && sessionStorage.getItem('adminDetails') !== null ){
        const token = JSON.parse(sessionStorage.getItem('adminDetails')).token;
       
        if(token !== ''){
                window.location.replace("/admin");
        }
    }
  }
  componentDidUpdate(){
    
  }

  handleInputValue = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }  

  submitForm = async (e) => {
    e.preventDefault();
    this.setState({loading:true})
    const {email ,password} = this.state

    if (this.validator.allValid()) {
        const res = await adminLogin({ email,password });
        if (res.status === 200) {
             this.setState({ loading: false });
             console.log("res",res)
             sessionStorage.setItem("adminDetails",JSON.stringify(res.data));
             window.location.replace("/admin")
            
        } else {
            this.setState({ loading: false });
        }
    } else {
        this.validator.showMessages();
        this.forceUpdate();
    }
 } 

    render(){
    
        return(<>
          <ToastContainer hideProgressBar={true} draggable={false}/>
             <div className="body-content-outer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3 bg-shadow bg-white radius-5 p-0">
                            <div className="content-header">
                            <a className="logo" href="javascript:void(0)"><img src="assests/images/logo.png" alt="img"/></a>
                            </div>
                            <div className="content-body">
                                <form className="m-0 form-fields" onSubmit={(e)=>this.submitForm(e)}>
                                    <div className="form-group">
                                        <input type="email" name="email" value={this.state.email} onChange={(e) => this.handleInputValue(e)} maxLength="50"  placeholder="Email" className="form-control" />
                                        {this.validator.message('email', this.state.email, 'required|email', { messages: { default: "Email field is required.", email: "Email must be a valid email address." } })}
                                    </div>
                                    <div className="form-group">
                                      <input type="password" name="password" maxLength="20" required="" value={this.state.password} onChange={(e) => this.handleInputValue(e)} placeholder="Password" className="form-control" />
                                       {this.validator.message('password', this.state.password, 'required', { messages: { default: 'Password field is required.'} })}
                                    </div>
                                    <div className="form-group text-right mt-4">
                                      <button type="submit" className="btn btn-red">{this.state.loading ? 'Please wait...': 'Login'}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }
}
export default Login